import script from "./SetLimitsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SetLimitsModal.vue?vue&type=script&setup=true&lang=js"

import "./SetLimitsModal.vue?vue&type=style&index=0&id=3aa20edc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa20edc"]])

export default __exports__